import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import Store from '@/services/Store';
import { General } from '@/services/General';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  silentFallbackWarn: true
});

const loadedLanguagesSession = [];

function setI18nLanguage(idCulture: string) {
    i18n.locale = idCulture;
    axios.defaults.headers.common['Accept-Language'] = idCulture;
    document.querySelector('html').setAttribute('lang', idCulture);
    return idCulture;
};

async function getDefaultIdCulture() {
  let response: any = await axios({
    method: 'get',
    url: General.GetApiUrl('/api/culture/GetDefaultIdCulture'),
    withCredentials: true
  });
  return response.data;
}

async function getTranslation(idCulture: string) {

  
  let response: any = await axios({
    method: 'get',
    url: General.GetApiUrl('/api/translation/GetTranslationJson?idCulture=' + idCulture),
    withCredentials: true
  });

  if(response.data != null) {
    let msgs = response.data;

    let newLanguage = {
      idCulture: idCulture,
      messages: msgs
    };

    let loadedLanguageIndex = loadedLanguagesSession.findIndex( lang => lang == idCulture );
    let oldLangIndex: number = Store.state.languages.findIndex(lang => lang["idCulture"] == newLanguage.idCulture);

    if(loadedLanguageIndex != -1 && oldLangIndex != -1){
      loadedLanguagesSession[loadedLanguageIndex] = newLanguage;
      Store.commit("UPDATE_LANGUAGE", newLanguage);
    }else{
      Store.commit("ADD_LANGUAGE", newLanguage);
      loadedLanguagesSession.push(idCulture);
    }

    i18n.setLocaleMessage(idCulture, msgs);
  }
}

export async function loadLanguageAsync(idCulture: string, forceReload: boolean = false) {
    let normalizedCulture = '';
    
    
    if(idCulture != null) {
      normalizedCulture = idCulture.toUpperCase();
    } else {
      normalizedCulture = await getDefaultIdCulture();
      normalizedCulture = normalizedCulture.toUpperCase();
    }
    
    let loadedLanguages = Store.state.languages;
    let index = loadedLanguages.findIndex(element => element.idCulture === normalizedCulture);

    if(index == -1 || forceReload) {
      await getTranslation(normalizedCulture);
    }
    if(normalizedCulture && i18n.locale !== normalizedCulture) {
      if(!loadedLanguagesSession.includes(normalizedCulture)){        
        let storeLanguage = loadedLanguages[index]; 
          i18n.setLocaleMessage(normalizedCulture, storeLanguage.messages);
          loadedLanguagesSession.push(normalizedCulture);
        }
      setI18nLanguage(normalizedCulture);
    }
}